module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightrain-a54451ef8b598fbb7d5939193fb08916.webp";